/**
 * Couper ou rouvrir le micro sur l'appel en cours.
 *
 * Le SDK Twilio est atteint par `window`, parce que l'appel actif est pose la
 * au decroche. Deux chemins, dans cet ordre : l'appel actif s'il est connu,
 * sinon tous les appels que le peripherique tient encore. La fonction dit si
 * elle a agi ; un bouton qui n'a rien coupe doit le dire plutot que de
 * changer d'apparence.
 *
 * Extrait de FloatingCallBar le 2026-09-30, quand la fiche contact a eu
 * besoin du meme bouton : recopier la logique aurait fait deux facons de
 * couper un micro, et une seule des deux aurait ete corrigee le jour venu.
 */
import { listDeviceCalls } from '@/lib/twilioDevice';

interface AppelTwilio {
  mute(silence: boolean): void;
}

interface PeripheriqueTwilio {
  calls?: AppelTwilio[];
}

interface FenetreTwilio {
  __twilioActiveCall?: AppelTwilio | null;
  __twilioDevice?: PeripheriqueTwilio;
}

/** Applique l'etat demande, et rend vrai seulement si un appel l'a pris. */
export function applyMute(silence: boolean, fenetre: FenetreTwilio = window as unknown as FenetreTwilio): boolean {
  const actif = fenetre.__twilioActiveCall;
  if (actif) {
    try {
      actif.mute(silence);
      return true;
    } catch {
      // On retombe sur les appels du peripherique plutot que d'abandonner.
    }
  }

  const peripherique = fenetre.__twilioDevice;
  const appels = listDeviceCalls<AppelTwilio>(peripherique);
  if (appels.length > 0) {
    let applique = false;
    appels.forEach((appel) => {
      try {
        appel.mute(silence);
        applique = true;
      } catch { /* cet appel-la refuse, les autres peuvent accepter */ }
    });
    return applique;
  }

  return false;
}
